/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "description_colors_default": "",
  "description_size_default": "",
  "description_variant_default": "hidden",
  "group_colors_default": "",
  "group_size_default": "mt-3 w-full gap-6",
  "group_variant_default": "flex flex-row flex-wrap overflow-x-auto",
  "headline_colors_default": "",
  "headline_size_default": "text-mb-headline",
  "headline_variant_default": "",
  "item_icon_colors_default": "",
  "item_icon_size_default": "",
  "item_icon_variant_default": "transition-transform group-active:translate-x-1",
  "item_image_colors_default": "bg-primary-100",
  "item_image_size_default": "w-16 h-16 data-[fill]:aspect-square",
  "item_image_variant_default": "rounded-full",
  "item_title_colors_default": "",
  "item_title_size_default": "text-mb-headline-xs",
  "item_title_variant_default": "grow",
  "item_colors_default": "bg-mb-gray-50",
  "item_size_default": "w-full min-w-88 gap-x-3 p-3",
  "item_variant_default": "flex flex-row items-center transition-colors group rounded",
  "colors_default": "",
  "size_default": "m-0",
  "variant_default": "flex flex-col gap-y-3"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ElementAuthorsList");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;